export const LOADING_PURCHASEORDERS = "LOADING_PURCHASEORDERS";
export const GET_PURCHASEORDERS_LIST = "GET_PURCHASEORDERS_LIST";
export const REMOVE_PURCHASEORDERS = "REMOVE_PURCHASEORDERS";
export const ADD_PURCHASEORDERS = "ADD_PURCHASEORDERS";
export const UPDATE_PURCHASEORDERS = "UPDATE_PURCHASEORDERS";
export const GET_PURCHASEORDERSBYID = "GET_PURCHASEORDERSBYID";
export const GET_PRODUCTORDER = "GET_PRODUCTORDER";
export const LOADING_PRODUCTORDER = "LOADING_PRODUCTORDER";

export const LOADING_PURCHASE_ORDER_DOCUMENT = "LOADING_PURCHASE_ORDER_DOCUMENT";
export const REMOVE_PURCHASE_ORDER_DOCUMENT = "REMOVE_PURCHASE_ORDER_DOCUMENT";
export const ADD_PURCHASE_ORDER_DOCUMENT = "ADD_PURCHASE_ORDER_DOCUMENT";
export const ADD_PURCHASE_ORDER_MULTI_DOCUMENT = "ADD_PURCHASE_ORDER_MULTI_DOCUMENT";
export const DOWNLOAD_PURCHASE_ORDER_DOCUMENT = "DOWNLOAD_PURCHASE_ORDER_DOCUMENT";
export const GET_PURCHASE_ORDER_DOCUMENT_LIST = "GET_QUOTATION_DOCUMENT_LIST";